/* The turn type a booking's options make it.
 *
 * A Classic Pedicure with Gel on it is a Gel Pedicure — a full turn, not a
 * half. But one option is often offered on very different services: Mangomint's
 * "Gel Polish" sits on manicures and pedicures alike, and one answer for it
 * would turn a manicure with Gel Polish into a pedicure. So a rule may say,
 * per turn type the booking was booked as (its base), what it becomes —
 * `byBase` — with `serviceId` the answer for any base the map does not name.
 *
 * Neither means the option leaves the booking alone: Gel Polish on an acrylic
 * toe set is still acrylic work. The first option with an answer wins; options
 * are in the order the booking system lists them, which is the order they
 * were added — the same as before there was a map at all.
 *
 *   options   [{ id }] on the booking
 *   rules     { optionId: { serviceId, byBase: { baseId: serviceId } } }
 *   baseId    the turn type the booked service maps to, or null
 *   exists    (serviceId) -> is that turn type still on the board
 *
 * Returns the turn type id, or null for "whatever it was booked as".
 */
export function optionTurnType(options, rules, baseId, exists) {
  var ok = exists || function () { return true; };
  var list = options || [];
  for (var i = 0; i < list.length; i++) {
    var r = rules && rules[list[i].id];
    if (!r) continue;
    var byBase = r.byBase || {};
    var target = baseId != null && byBase[baseId] ? byBase[baseId] : r.serviceId;
    if (target && ok(target)) return target;
  }
  return null;
}
